var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row mt-5"},[_c('div',{staticClass:"vx-col w-1/2"},[_vm._t("footer-left")],2),_c('div',{staticClass:"vx-col w-1/2 flex items-end"},[_vm._t("footer-right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }